import * as React from 'react';
import './index.scss';

const isMacOS = () => {
  return /macintosh|mac os x/i.test(navigator.userAgent.toLowerCase());
};

const MAC_PLATFORM = isMacOS();

enum ShortcutKey {
  Ctrl = 'ctrl',
  Alt = 'alt',
  Shift = 'shift',
}

interface IProps {
  readonly children: React.ReactNode;

  // shortcut keys allow multiple modes
  // 1. single => ['escape']
  // 2. combination (no order) => ['ctrl+x', 'ctrl+z', 'a+alt']
  readonly shortcutKeys: ReadonlyArray<string> | string;
  readonly onEmit?: (shortcutKey: string) => void;
}

export const Keyboard = (props: IProps) => {
  const formatShortcutKeys = () => {
    const keys =
      typeof props.shortcutKeys === 'string'
        ? [props.shortcutKeys]
        : props.shortcutKeys;
    return keys.map((item) => item.toLocaleLowerCase());
  };

  const matchSingleShortcutKey = (
    event: React.KeyboardEvent<HTMLDivElement>,
    eventKey: string,
    combinationKeys: ReadonlyArray<string>
  ) => {
    let hitLen = 0;
    combinationKeys.forEach((key) => {
      const ctrlKey = MAC_PLATFORM ? event.metaKey : event.ctrlKey;
      if (ctrlKey && key === ShortcutKey.Ctrl) {
        hitLen = hitLen + 1;
      }
      if (event.altKey && key === ShortcutKey.Alt) {
        hitLen = hitLen + 1;
      }
      if (event.shiftKey && key === ShortcutKey.Shift) {
        hitLen = hitLen + 1;
      }
      if (key === eventKey) {
        hitLen = hitLen + 1;
      }
    });
    return hitLen === combinationKeys.length;
  };

  // only supports single shortcut key hit
  const hitEventKey = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const shortcutKeys = formatShortcutKeys();
    const eventKey = event.key.toLocaleLowerCase();
    const hitShortcutKey = shortcutKeys.find((shortcutKey) => {
      const combinationKeys = shortcutKey.replace(/\s+/g, '').split('+');
      return matchSingleShortcutKey(event, eventKey, combinationKeys);
    });
    return hitShortcutKey;
  };

  const onHandleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const hitEvent = hitEventKey(event);
    if (hitEvent) {
      props.onEmit?.(hitEvent);
    }
  };

  return <div onKeyDown={onHandleKeyDown}>{props.children}</div>;
};
